import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames'

import BarcodeImage from '../images/sample_barcode.png'


export default class RepairRow extends React.Component {

  render () {
    const {repair, prices, columns, displayBarcodes, displayTime} = this.props

    const repairRowClasses    = classnames( 'repair-row',         {'is-not-printed': !repair.printed} )
    const numberClasses       = classnames( 'repair-number')
    const descriptionClasses  = classnames( 'repair-description', {locked: repair.descriptionLocked} )
    const commentsClasses     = classnames( 'repair-comments',    {locked: repair.commentsLocked} )
    const nameClasses         = classnames( 'repair-name',        {locked: repair.descriptionLocked || repair.commentsLocked} )

    const showPricingDetails  = false

    return (
      <tr className={repairRowClasses}>
        <td className={numberClasses}>
          <div>
            { repair.number}
            { displayTime ? <span className="encoded-labor-time">-{repair.encodedLaborTime}</span> : null }
            { displayBarcodes ? <img alt="barcode" className="repair-barcode" src={BarcodeImage}/> : null }
          </div>
        </td>
        <td className={nameClasses}>
          <div className={descriptionClasses}> {repair.description} </div>
          <div className={commentsClasses}> {breakify(repair.comments)} </div>
        </td>

        {prices.map((price, i) => {

          const cellClasses = classnames(
            'total-price',
            {'locked':         price.locked},
            {'is-not-printed': !columns[i].printed},
            {'book-highlight':  columns[i].highlighted}
          )

          return (
            <td className={cellClasses} key={`price-${i}`}>
              <span className="price-label-indent"></span>
              <span className="price-label">{columns[i].title}</span>
              <span className={classnames('repair-price', {
                  'locked':         (price.locked || price.partsLocked || price.laborLocked) && showPricingDetails,
                  'is-not-printed': repair.printed && !columns[i].printed,
                })}>
                  {price.total}
              </span>
              <div className="left-padding"></div>
              <div className="right-padding"></div>
            </td>
          )
        })}
      </tr>
    )
  }
}


RepairRow.propTypes = {
  repair: PropTypes.object.isRequired,
  prices: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  displayBarcodes: PropTypes.bool.isRequired,
  displayTime: PropTypes.bool.isRequired,
}


var ZERO_WIDTH_WHITESPACE = String.fromCharCode(8203)
function breakify (s) {
  if (!s) return s
  // Add zero-width spaces so LONG comments won't wreck layout on small devices
  return s.replace(/,/g, ',' + ZERO_WIDTH_WHITESPACE).replace(/\//g, '/' + ZERO_WIDTH_WHITESPACE)
}

